/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.LOCATIONS_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.locations,
                (memo, location) => {
                    const { id } = location;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = location;
                    return memo;
                },
                state,
            );
        },
        [actions.DELETE_LOCATION_SUCCESS]: (state, action) => {
            const locationId = get(action, ['payload', ['locationId']]);
            const items = { ...state };
            return omitBy(items, { id: locationId })
        }
    },
);